import React from 'react';
import ptBR from 'antd/lib/locale/pt_BR';
import 'moment/locale/pt-br';
import { Route, Router, Switch } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import history from './utils/history';
import ExternalLayout from './layout/externalLayout';
import BasicLayout from './layout/basicLayout';
import './service/interceptors';
import './index.css';
import ThemeProvider from './context/theme';
import AnchorProvider from './context/anchor';
const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AnchorProvider>
        <ConfigProvider locale={ptBR}>
          <Router history={history}>
            <Switch>
              <Route path="/dashboard">
                <BasicLayout />
              </Route>

              <Route path="/">
                <ExternalLayout />
              </Route>
            </Switch>
          </Router>
        </ConfigProvider>
      </AnchorProvider>
    </ThemeProvider>
  );
};

export default App;
